import { render } from "./Score.vue?vue&type=template&id=5ac2deaa&scoped=true"
import script from "./Score.vue?vue&type=script&lang=js"
export * from "./Score.vue?vue&type=script&lang=js"

import "./Score.vue?vue&type=style&index=0&id=5ac2deaa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/cloud-builder-challenge-frontend/cloud-builder-challenge-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac2deaa"]])

export default __exports__